import { render, staticRenderFns } from "./syssetting-employee.vue?vue&type=template&id=254820e7&scoped=true"
import script from "./syssetting-employee.vue?vue&type=script&lang=js"
export * from "./syssetting-employee.vue?vue&type=script&lang=js"
import style0 from "./syssetting-employee.vue?vue&type=style&index=0&id=254820e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254820e7",
  null
  
)

export default component.exports